import React, { useState, useEffect } from 'react';
import styles from './AnalyticsLegal.module.css'; // Изменено на CSS-модуль
import DiscountChart from "../AmbassadorsFolder/DiscountChart";
import AmbassadorByDiscountChart from "../AmbassadorsFolder/AmbassadorByDiscountChart";

export default function AnalyticsLegal() {
  // Состояния для статистики
  const [buyers, setBuyers] = useState(4);
  const [personalSales, setPersonalSales] = useState(3651239);
  const [salesFunnel, setSalesFunnel] = useState(10);
  const [funnelVolume, setFunnelVolume] = useState(36778112);
  const [activations, setActivations] = useState(['Активация 1', 'Активация 2', 'Активация 3']);
  const userId = 'yourUserId'; // Замените на реальный userId

  const [purchaseHistory, setPurchaseHistory] = useState([
    { name: "Айдана Ермек", amount: 1000, discount: 5 },
    { name: "Нурлан Касен", amount: 2000, discount: 7 },
    { name: "Жанна Т.", amount: 1500, discount: 10 },
  ]);


  // Эффект для загрузки данных с бэкенда
  useEffect(() => {
    fetch(`http://localhost:8083/api/v1/${userId}`)
      .then(response => response.json())
      .then(data => {
        setBuyers(data.buyers);
        setPersonalSales(data.personalSales);
        setSalesFunnel(data.salesFunnel);
        setFunnelVolume(data.funnelVolume);
        setActivations(data.activations);
      })
      .catch(error => {
        console.error('Ошибка при загрузке данных:', error);
      });
  }, [userId]); // Зависимость от userId

  // Функция для добавления новой активации и отправки данных на сервер
  const addActivation = () => {
    const newActivation = `Активация ${activations.length + 1}`;
    const updatedActivations = [...activations, newActivation];
    setActivations(updatedActivations);

    // Отправляем данные на сервер
    fetch(`http://localhost:8083/api/v1/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        buyers,
        personalSales,
        salesFunnel,
        funnelVolume,
        activations: updatedActivations
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Данные успешно отправлены:', data);
      })
      .catch(error => {
        console.error('Ошибка при отправке данных:', error);
      });
  };

  return (
    <div className={styles.containerM}>
      <div className={styles.containerC}>
        <div className={styles.container}>
          <h1>Аналитика по продажам амбассадоров</h1>

          

          {/* Аналитика Графы */}
          <div className={styles.chartWrapper}>
            <div className={styles.chartBlock}>
              <DiscountChart purchaseHistory={purchaseHistory} />
            </div>
            <div className={styles.chartBlock}>
              <AmbassadorByDiscountChart purchaseHistory={purchaseHistory} />
            </div>
          </div>



        </div>

      </div>
    </div>
  );
}
